import { FaTractor, FaHelicopter, FaTrailer, FaTruck, FaRegEye, FaCarSide, FaMotorcycle } from 'react-icons/fa';
import { GiTruck, GiBus } from 'react-icons/gi';
import HubRoundedIcon from '@mui/icons-material/HubRounded';

export const fields = [
  { name: 'social_reason', label: 'Razão Social', type: 'text' },
  { name: 'fantasy_name', label: 'Nome Fantasia', type: 'text' },
  { name: 'cnpj', label: 'CNPJ', type: 'text' },
  { name: 'email', label: 'E-mail do responsável', type: 'email' },
  { name: 'cep', label: 'CEP', type: 'text' },
  { name: 'number', label: 'Telefone / Celular do responsável', type: 'text' },
  { name: 'contract_start', label: 'Início de contrato', type: 'date' },
  { name: 'contract_end', label: 'Término de contrato', type: 'date' }
];

export const booleanChips = [
  { name: 'api_user', label: 'Permitir integração?',icon: <HubRoundedIcon /> },
  { name: 'can_download_full_table', label: 'Permitir fazer download tabela full?', icon: <FaRegEye /> },
  { name: 'can_query_chassi_or_plate', label: 'SEMIRREBOQUE - Pode consultar por placa ou chassi ?', icon: <FaRegEye /> },
  { name: 'can_query_chassi_or_plate_bus_truck', label: 'CAMINHÕES E ÔNIBUS - Pode consultar por placa ou chassi ?', icon: <FaRegEye /> },
];

export const productsData = [
  { id: '1', label: 'Trator', icon: <FaTractor />, inputId: 'tr_balance', inputName: 'tr_balance', valueKey: 'tr_balance' },
  { id: '2', label: 'Helicóptero', icon: <FaHelicopter />, inputId: 'hp_balance', inputName: 'hp_balance', valueKey: 'hp_balance' },
  { id: '3', label: 'Semirreboque', icon: <FaTrailer />, inputId: 'sr_balance', inputName: 'sr_balance', valueKey: 'sr_balance' },
  { id: '4', label: 'Carroceria', icon: <FaTruck />, inputId: 'cr_balance', inputName: 'cr_balance', valueKey: 'cr_balance' },
  { id: '5', label: 'Caminhão e Ônibus', icon: <div style={{ display: 'flex', flexWrap: 'nowrap' }}><GiTruck /><GiBus /></div>, inputId: 'cm_balance', inputName: 'cm_balance', valueKey: 'cm_balance' },
  { id: '6', label: 'Colheitadeira', icon: null, inputId: 'hv_balance', inputName: 'hv_balance', valueKey: 'hv_balance' },
  { id: '7', label: 'LEVES (0km)', icon:<> <FaMotorcycle /><FaCarSide/></>, inputId: 'lw_balance', inputName: 'lw_balance', valueKey: 'lw_balance' },
];